// Copyright (c) Docugami, Inc. All rights reserved.

import { createSelector } from "@reduxjs/toolkit"
import { useAppSelector } from "hooks/redux"
import { AppState } from "store"
import { selectGetReviewDocumentsState } from "store/reports/reportsSlice"
import { AutomationId } from "utils/Automation"
import { HeaderButton } from "./WorkPathHeaderComponents"
import { selectReportId, selectReviewFeedbackLockStats } from "store/reports/selectors"

interface ReportReviewButtonProps {
    className?: string;
    onPublish: () => void;
}

export const ReportReviewButton = (props: ReportReviewButtonProps) => {
    const reportId = useAppSelector(selectReportId);
    const allBindingsConfirmed = useAppSelector(state => selectAllBindingsConfirmed(state, reportId));

    return (
        <HeaderButton
            className={props.className}
            disabled={!allBindingsConfirmed}
            data-automation-id={AutomationId.ReportReviewPublishButton}
            text='PUBLISH'
            primary
            onClick={props.onPublish} />
    )
}

const selectAllBindingsConfirmed = createSelector(
    [
        (state: AppState, reportId: string) => selectReviewFeedbackLockStats(state)?.documentsAllLocked,
        (state: AppState, reportId: string) => selectGetReviewDocumentsState(state, reportId)?.documents.ids
    ],
    (confirmationLookup, documentIds): boolean => {
        if (!confirmationLookup || !documentIds || !documentIds.length) {
            return false;
        }

        for (const id of documentIds) {
            if (!confirmationLookup[id]) {
                return false;
            }
        }

        return true;
    }
)
